import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import DiscountContext from '~/context/common/DiscountContext';
import { fetchDiscounts } from '~/services/common';
import generateErrorLogger from '~/utilities/errorHandlers';

export default function useGetDiscountContext(
  stateAbbreviation: string,
  userId: string
) {
  const {
    discounts: { setData, setError, setLoading }
  } = useContext(DiscountContext);

  useEffectWithController(
    controller => {
      setLoading();

      fetchDiscounts(stateAbbreviation, userId, controller)
        .then(res => setData(res.data.content?.discounts ?? []))
        .catch(
          generateErrorLogger('Get discounts', {}, { callback: setError })
        );
    },
    [setData, setError, setLoading, stateAbbreviation, userId]
  );
}
